export const SET_MANAGED_USER_ENTERPRISE = "SET_MANAGED_USER_ENTERPRISE";
export const SET_MANAGED_USER = "SET_MANAGED_USER";
export const SET_USER = "SET_USER";
export const LOGIN_CHECK = "LOGIN_CHECK";
export const TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION = "TOGGLE_MANAGED_USER_ENTERPRISE_PERMISSION";


// WEBPACK FOOTER //
// ./src/components/user/actions/types.js